import { render } from "./SearchResultsIndividual.vue?vue&type=template&id=4c27de04&scoped=true"
import script from "./SearchResultsIndividual.vue?vue&type=script&lang=js"
export * from "./SearchResultsIndividual.vue?vue&type=script&lang=js"

import "./SearchResultsIndividual.vue?vue&type=style&index=0&id=4c27de04&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c27de04"]])

export default __exports__